// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"Property_cardContainer__1ERRN","margin":"Property_margin__1PHNT"};